// Portales inmobiliarios sobre los que busca el botón "¿Está publicado?"
// (Sprint UX + Publicado, 2026-02).
//
// Regla del sprint: "que agregar un portal sea una línea". Los 7 mismos están
// también configurados en el Programmable Search Engine (cx) del lado de Google;
// esta lista se usa para armar el link de FALLBACK (site: A OR site: B OR …)
// que no conoce el cx.
export const PORTALES_BUSQUEDA = [
  "zonaprop.com.ar",
  "argenprop.com",
  "inmuebles.mercadolibre.com.ar",
  "properati.com.ar",
  "remax.com.ar",
  "clasificados.lavoz.com.ar",
  "agrofy.com.ar",
];

// cx del Programmable Search Element. NO es una credencial (viaja al cliente
// por diseño de Google); va en env por prolijidad y para poder cambiarlo sin
// tocar código.
export const CSE_ID = process.env.REACT_APP_GCSE_CX || "";

/**
 * Arma la query de búsqueda de un lote — UNA sola función para los dos niveles
 * (widget y fallback). Casos:
 *   A) direccion tiene número → exacta, con comillas: '"Las Playas 1958"'
 *   B) sin número → aproximada, sin comillas: 'Las Playas Villa Cabrera Córdoba terreno lote'
 *   Sin dirección → null (el botón queda deshabilitado con motivo).
 */
export function buildDireccionQuery(lote) {
  const direccion = (lote?.direccion || "").trim();
  if (!direccion) return null;

  const barrio = (lote?.barrio || "").trim();
  const localidad = (lote?.localidad || "Córdoba").trim();

  const tieneNumero = /\d/.test(direccion);

  if (tieneNumero) {
    return {
      query: `"${direccion}"`,
      queryPlana: direccion,
      tipo: "exacta",
      etiqueta: "Búsqueda por dirección exacta",
    };
  }

  // Sin número — arma contexto para que el aviso sea más matcheable
  const partes = [direccion];
  if (barrio && barrio !== direccion) partes.push(barrio);
  if (localidad) partes.push(localidad);
  partes.push("terreno lote");
  const query = partes.join(" ");
  return {
    query,
    queryPlana: query,
    tipo: "aproximada",
    etiqueta: "⚠️ Búsqueda aproximada — el lote no tiene numeración",
  };
}

/**
 * URL del fallback: link a Google.com abierto en pestaña nueva.
 * Incluye los site: porque el link NO conoce el cx del widget.
 */
export function buildGoogleFallbackUrl(query) {
  const sites = PORTALES_BUSQUEDA.map((d) => `site:${d}`).join(" OR ");
  const full = `${query} (${sites})`;
  return `https://www.google.com/search?q=${encodeURIComponent(full)}`;
}
